import { TranslationNamespaces } from '~/lib/constants';

export const CentimetreAbbreviation = {
  key: 'CENTIMETRE_ABBREVIATION',
  options: { defaultValue: 'cm', ns: TranslationNamespaces.COMMON }
};
export const KilogramAbbreviation = {
  key: 'KILOGRAM_ABBREVIATION',
  options: { defaultValue: 'kg', ns: TranslationNamespaces.COMMON }
};
